import { render, staticRenderFns } from "./ArticleShow.vue?vue&type=template&id=511a715f&scoped=true"
import script from "./ArticleShow.vue?vue&type=script&lang=js"
export * from "./ArticleShow.vue?vue&type=script&lang=js"
import style0 from "./ArticleShow.vue?vue&type=style&index=0&id=511a715f&prod&lang=css"
import style1 from "./ArticleShow.vue?vue&type=style&index=1&id=511a715f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a715f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleByline: require('/app/components/ArticleByline.vue').default,ProductSliderListItem: require('/app/components/ProductSliderListItem.vue').default,FaqList: require('/app/components/FaqList.vue').default})
